























































































import Vue from 'vue';
import axios from 'axios';
// import * as firebase from '@/plugins/firebase';
// import { firebase } from 'mostra';
// import buyer from '@/modules/buyer/buyer';
// import company from '@/modules/buyer/company';
import {
  // buyer,
  // Buyer,
  // buyerCompany as company,
  // BuyerCompany as Company
  firebase,
} from 'mostra';
// import { v4 } from 'uuid';
const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const s = parts.pop();
    if (!s) return null;
    return s
      .split(';')
      .shift();
  }
  return null;
};

export type DataType = {
  email: string;
  password: string;
}
export default Vue.extend({
  name: 'setting-auth-signup',
  data(): DataType {
    return {
      email: '',
      password: '',
    };
  },
  computed: {
    showMessage() {
      if (this.$route.query && this.$route.query.at) {
        return Number(this.$route.query.at) === 1;
      } else {
        return null;
      }
    },
  },
  methods: {
    async onClickEmail() {
      try {
        this.$loading(true);
        const email = this.email;
        const password = this.password;
        const credential = await firebase
          .EmailAuthProvider
          .credential(email, password);
        const auth = await firebase.auth().currentUser;
        if (!auth) throw Error('ユーザ情報を取得できませんでした。 User information could not be obtained.');
        await auth.linkWithCredential(credential);
        await firebase
          .functions('createBuyerData', {
            email,
          });

        const rdCode = getCookie('rd_code_moshimo');

        if (rdCode) {
          await axios.get('https://r.moshimo.com/af/r/result', {
            params: {
              p_id: 5899,
              pc_id: 16417,
              m_v: auth.uid,
              rd_code: rdCode,
            },
          });
        }

        window.location.href = '/web/auth/register';
      } catch (error: any) {
        if (error.code && error.code === 'auth/email-already-in-use') {
          this.$error('このメールアドレスはすでに使用されています。');
        } else if (error.message) {
          this.$error('サインアップに失敗しました。', error.message);
        } else {
          this.$error('サインアップに失敗しました。', error);
        }
      } finally {
        this.$loading(false);
      }
    },
  },
});
